import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 1280.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">

<path d="M8820 10486 c-221 -62 -381 -300 -430 -641 -6 -44 -13 -91 -16 -105
-3 -14 -9 -272 -13 -575 -8 -527 -9 -553 -30 -625 -52 -174 -163 -274 -319
-287 -230 -19 -396 113 -464 368 -22 82 -23 98 -23 574 l0 490 33 67 c19 39
48 80 70 97 l37 31 -315 0 -314 0 38 -37 c22 -21 53 -67 70 -103 l31 -65 5
-540 c6 -528 6 -542 29 -610 49 -152 123 -246 238 -303 120 -61 307 -85 475
-62 205 28 327 106 398 255 54 115 60 170 60 547 0 189 5 404 10 478 30 392
132 655 327 846 103 101 214 148 376 160 48 4 87 10 87 14 0 13 -164 40 -240
39 -41 0 -95 -6 -120 -13z"/>
<path d="M2831 10230 c-102 -14 -171 -31 -171 -41 0 -13 23 -11 147 7 74 11
149 15 238 12 115 -4 142 -9 230 -38 156 -53 309 -163 465 -337 l70 -78 -2
-655 -3 -655 -24 -63 c-30 -79 -94 -152 -163 -186 l-52 -26 260 0 259 1 -55
29 c-67 35 -120 89 -154 155 -46 93 -50 168 -40 789 l9 569 91 -139 c50 -77
160 -267 244 -424 253 -473 379 -694 514 -897 l81 -123 162 0 c90 0 163 2 163
5 0 2 -32 65 -71 139 l-70 135 3 603 c3 603 3 603 26 660 30 74 103 155 167
184 l50 24 -260 0 -260 0 51 -24 c103 -48 174 -155 194 -291 10 -75 11 -489 1
-860 l-6 -230 -79 170 c-176 379 -281 574 -420 780 -316 467 -624 693 -1086
795 -68 15 -422 22 -509 10z"/>
<path d="M4590 10234 c-14 -2 -67 -11 -117 -20 -85 -14 -102 -21 -88 -36 3 -2
53 4 112 13 152 25 337 25 439 -1 175 -44 334 -148 503 -326 l101 -107 0 -621
c0 -675 -3 -708 -56 -805 -33 -62 -75 -102 -139 -135 l-50 -25 260 0 260 0
-53 27 c-69 34 -144 116 -174 190 l-23 57 -3 628 c-2 486 0 628 9 625 32 -11
170 -235 334 -543 126 -237 161 -300 287 -525 84 -150 198 -334 262 -426 l51
-74 163 0 c89 0 162 4 162 8 0 4 -4 12 -9 18 -4 5 -36 62 -70 127 l-61 118 0
594 0 594 24 66 c39 108 81 157 181 209 28 14 12 15 -225 15 l-255 -1 52 -24
c108 -51 180 -169 192 -314 3 -41 4 -298 1 -570 l-5 -495 -21 45 c-12 25 -65
137 -118 250 -425 900 -820 1306 -1405 1441 -67 16 -131 21 -291 24 -113 2
-216 2 -230 -1z"/>
<path d="M2725 9869 c-378 -39 -609 -218 -745 -578 l-36 -94 -86 -17 c-49 -10
-112 -32 -145 -49 -67 -36 -193 -128 -193 -142 0 -20 34 -7 73 27 64 54 172
103 255 116 40 6 75 8 77 6 3 -3 -1 -20 -7 -39 -18 -48 -17 -356 1 -429 131
-533 141 -586 141 -725 0 -174 -32 -261 -131 -356 -32 -31 -91 -73 -131 -94
-88 -46 -84 -43 -70 -57 9 -9 32 -2 94 30 194 96 301 239 348 462 20 98 29
358 23 670 -5 281 2 431 23 503 16 52 260 -15 417 -116 92 -58 156 -128 200
-217 l32 -65 0 -185 c0 -167 -2 -189 -21 -230 -20 -43 -45 -72 -89 -105 -18
-13 15 -14 290 -14 l310 -1 -36 22 c-20 11 -46 37 -57 57 -41 75 -43 115 -40
811 3 657 3 666 25 712 13 29 37 58 64 77 l42 31 -274 -1 c-151 -1 -310 -5
-354 -10z m95 -57 c46 -35 48 -65 49 -566 l1 -468 -41 60 c-108 163 -319 296
-526 332 -84 15 -81 2 -31 155 63 192 154 343 258 430 94 79 226 105 290 57z"/>
<path d="M8705 9865 c47 -35 75 -71 92 -119 17 -47 18 -104 18 -731 l0 -680
-23 -47 c-13 -26 -42 -63 -63 -83 l-39 -35 307 0 308 0 -38 22 c-44 26 -81 94
-97 177 -5 29 -10 148 -10 262 l0 209 53 0 c226 -1 370 -111 572 -435 10 -16
50 -88 88 -160 134 -254 263 -418 397 -504 99 -64 150 -76 320 -75 130 0 153
3 225 27 89 30 173 74 240 127 41 32 62 70 33 57 -178 -78 -270 -97 -377 -78
-200 36 -360 158 -653 501 -285 332 -445 469 -608 521 -62 19 -68 16 85 43
172 30 331 132 404 259 96 168 75 406 -47 542 -104 116 -250 181 -457 205 -49
5 -238 10 -420 10 -291 -1 -328 -2 -310 -15z m726 -44 c153 -58 239 -221 239
-452 0 -182 -40 -300 -134 -394 -70 -70 -138 -96 -273 -103 l-103 -5 0 493 0
493 108 -6 c74 -3 124 -11 163 -26z"/>
<path d="M4501 7911 c-7 -5 -15 -26 -18 -49 -5 -36 -12 -45 -62 -78 -73 -48
-187 -166 -229 -237 -59 -97 -85 -189 -86 -297 -1 -112 7 -153 32 -148 13 3
16 11 12 48 -8 77 -2 174 14 230 21 69 76 170 129 233 41 49 157 150 165 143
1 -2 -46 -251 -107 -552 -60 -302 -117 -592 -126 -644 -22 -126 -24 -132 -38
-90 -7 19 -19 35 -27 35 -23 0 -16 -62 11 -98 21 -29 21 -34 10 -106 -16 -106
-15 -160 4 -167 20 -8 43 12 61 54 15 37 12 52 -12 52 -15 0 -18 35 -8 88 6
27 10 30 57 36 28 4 83 24 122 44 96 50 278 231 364 362 165 251 274 563 275
795 1 124 -15 180 -70 243 -62 70 -129 96 -239 89 -46 -2 -106 -13 -140 -26
-75 -27 -76 -27 -69 8 6 31 -4 44 -25 32z m334 -62 c54 -14 120 -69 141 -118
82 -192 -27 -616 -241 -936 -144 -214 -327 -371 -445 -383 -28 -2 -50 -2 -50
1 0 3 4 28 9 54 6 26 17 89 26 138 22 115 89 453 160 805 30 151 60 299 66
328 11 57 23 67 111 96 81 27 155 32 223 15z"/>
<path d="M7045 7819 c-35 -43 -67 -108 -99 -204 -51 -150 -242 -966 -248
-1055 -2 -34 1 -45 13 -48 12 -2 22 14 39 60 58 158 166 343 200 343 9 0 18
-15 23 -37 4 -21 10 -54 15 -75 4 -21 18 -44 33 -56 26 -18 28 -18 63 -2 45
21 107 89 174 191 39 59 49 81 41 91 -15 18 -23 11 -71 -60 -90 -134 -164
-205 -189 -180 -5 5 -14 38 -20 72 -12 78 -26 101 -61 101 -38 0 -86 -45 -132
-124 -40 -69 -53 -82 -42 -43 3 12 31 130 62 262 55 235 58 243 135 399 113
226 155 374 113 390 -22 8 -19 10 -49 -25z m1 -110 c-24 -71 -78 -191 -84
-184 -5 5 12 56 60 173 34 82 49 90 24 11z"/>
<path d="M5769 7707 c-6 -12 -23 -72 -38 -132 l-27 -110 -214 -10 c-199 -9
-215 -11 -218 -29 -4 -18 3 -19 207 -12 116 4 211 5 211 1 0 -3 -29 -135 -65
-293 -96 -427 -195 -940 -195 -1008 0 -25 21 -46 36 -36 23 15 36 52 23 68
-15 18 -6 75 72 464 69 343 97 472 142 665 l33 140 240 8 c229 8 468 3 527 -9
23 -5 27 -3 27 15 0 14 -9 23 -27 28 -16 5 -191 7 -390 6 -200 0 -363 2 -363
5 0 4 14 60 30 125 17 65 28 122 25 128 -10 16 -25 10 -36 -14z"/>
<path d="M8527 7190 c-97 -85 -164 -360 -106 -434 50 -63 116 -53 211 33 76
69 180 198 176 219 -6 30 -25 22 -58 -25 -45 -64 -136 -159 -184 -194 -75 -55
-126 -29 -126 66 0 81 14 112 89 190 71 75 96 124 79 158 -13 25 -43 21 -81
-13z m26 -51 c-21 -36 -43 -57 -43 -41 0 11 48 72 56 72 3 0 -3 -14 -13 -31z"/>
<path d="M5157 7108 c-76 -73 -133 -251 -92 -291 24 -25 54 -8 114 65 63 78
54 82 82 -31 15 -60 60 -105 96 -96 58 14 123 86 182 202 26 53 27 73 1 73
-11 0 -20 -6 -20 -13 0 -21 -98 -174 -126 -196 -63 -50 -87 -22 -108 129 -8
61 -16 85 -26 85 -7 0 -38 -31 -67 -70 -100 -131 -117 -136 -84 -26 36 119
112 193 151 147 16 -20 50 -21 50 -2 0 23 -50 56 -86 56 -23 0 -42 -9 -67 -32z"/>
<path d="M5889 7117 c-58 -39 -132 -219 -114 -277 3 -11 15 -25 25 -30 16 -9
27 -4 58 25 22 19 52 53 67 75 15 22 31 38 35 35 4 -2 10 -25 13 -50 27 -194
143 -186 263 19 19 32 38 72 41 87 9 46 -23 36 -48 -13 -29 -57 -91 -148 -117
-171 -27 -25 -64 -18 -79 14 -7 15 -19 66 -26 115 -7 48 -17 89 -24 91 -6 2
-32 -24 -59 -59 -56 -75 -95 -118 -106 -118 -23 0 31 152 73 203 33 40 61 46
93 22 46 -35 65 -1 20 34 -35 27 -73 27 -115 -2z"/>
<path d="M7832 7128 c-17 -22 -89 -249 -103 -326 -9 -53 -9 -76 -1 -84 19 -19
38 -1 82 78 23 42 59 102 79 133 l36 56 6 -70 c7 -79 14 -101 35 -109 29 -11
54 15 95 102 l42 87 17 -52 c9 -29 23 -59 30 -68 16 -20 72 -19 113 1 44 22
137 114 137 136 0 28 -23 21 -61 -18 -50 -53 -109 -94 -135 -94 -30 0 -44 27
-52 103 -6 57 -9 62 -32 62 -21 0 -32 -14 -77 -100 -28 -55 -56 -101 -62 -103
-7 -2 -11 30 -11 96 0 151 -25 146 -131 -28 -29 -49 -55 -87 -57 -85 -2 2 17
65 42 140 25 76 46 141 46 146 0 13 -26 11 -38 -3z"/>
<path d="M7412 7075 c-11 -14 -25 -25 -30 -25 -17 0 -51 -50 -62 -91 -23 -83
20 -159 88 -159 28 0 42 8 72 40 28 31 44 40 69 40 17 0 51 9 74 21 47 24 117
87 117 105 0 29 -25 24 -63 -14 -48 -46 -95 -72 -130 -72 -23 0 -25 4 -29 70
-6 77 -25 110 -64 110 -12 0 -31 -11 -42 -25z m62 -41 c11 -29 7 -86 -6 -82
-20 7 -40 56 -33 78 8 24 30 26 39 4z m-37 -115 c21 -23 23 -30 14 -48 -12
-22 -53 -37 -70 -27 -17 11 -30 74 -21 106 14 50 22 55 38 24 8 -16 25 -41 39
-55z"/>
<path d="M6357 6994 c-3 -3 -3 -12 0 -20 4 -11 33 -14 139 -14 127 0 134 1
134 20 0 19 -7 20 -133 20 -74 0 -136 -3 -140 -6z"/>
</g>
</svg>





    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
